import React, { Component } from 'react';
import './index.scss';
import close from '../../../../assets/imgs/input-delete.png';

const videoList = [
  '地磁安装规范指导',
  '地磁激活调试指导视频',
  '6.92版本后地磁激活调试指导视频',
  'NB地磁网络监控测试指导',
  '地磁程序现场手动升级方法'
];
const videoUrlList = [
  'https://city.parking24.cn/geo_video/1-install-20210616.mp4',
  'https://city.parking24.cn/geo_video/2-active-20210616.mp4',
  'https://city.parking24.cn/geo_video/2-activ-6.92-20210616.mp4',
  'https://city.parking24.cn/geo_video/3-network-20210702_1.mp4',
  'https://city.parking24.cn/geo_video/4-upgrade_1.mp4'
];


class Video extends Component {
  constructor(props) {
    super(props);
    this.videoRef = React.createRef();
  }

  state = {
    isplay: false,
    video: '',
  }

  closeVideo = (e) => {
    e.stopPropagation();
    // 关闭视频
    this.videoRef.current.pause();
    this.props.onhideVideo();
    this.setState({
      isplay: false
    });
  }

  play = (e, index) => {
    e.stopPropagation();
    // 播放对应的视频
    this.setState({
      isplay: true,
      video: videoUrlList[index]
    });
  }

  render() {
    const { showVideo } = this.props;
    const { isplay, video } = this.state;

    return (
      <div className="video-list" style={{ display: showVideo ? 'inline-flex' : 'none' }} onClick={() => { this.props.onhideVideo(); }}>
        <div className="video-ul">
          <h3 className="ul-name">教学视频列表</h3>
          {
            videoList.map((item, index) => {
              return (
                <div className="video-item" key={index} onClick={(e) => { this.play(e, index); }}>{item}</div>
              );
            })
          }
        </div>
        <div className="video-wrap" style={{ display: isplay ? 'inline-flex' : 'none' }}>
          <img src={close} className="close-video" onClick={(e) => { this.closeVideo(e); }} alt="关闭" />
          <video ref={this.videoRef} src={video} autoPlay controls width="100%" height="100%"></video>
        </div>
      </div>
    );
  }
}

export default Video;
